<template>
  <el-dialog
    title="更换面试官"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="500px"
    @close="handleClose"
  >
    <ul class="replace-header">
      <li>
        <span class="label">T3： </span>
        <span class="value">{{ detailObj.branch }}</span>
      </li>
      <li>
        <span class="label">T4： </span>
        <span class="value">{{ detailObj.area }} </span>
      </li>
      <li>
        <span class="label"> 姓名： </span>
        <span class="value">{{ detailObj.accountName }}</span>
      </li>
    </ul>
    <el-form :model="form" :rules="rules"  ref="formRef" label-width="100px">
      <!-- 招募安排 -->
      <el-form-item label="招募安排">
        <el-select disabled v-model="form.step" placeholder="请选择">
          <el-option
            v-for="(ite,idx) in stepList"
            :key="idx"
            :label="ite.label"
            :value="ite.value"
            />
        </el-select>
      </el-form-item>
      <!-- 当前面试官： -->
      <el-form-item label="当前面试官">
        <el-select disabled v-model="form.interviewerType" placeholder="请选择">
          <el-option
            v-for="(ite,idx) in interviewerList"
            :key="idx"
            :label="ite.label"
            :value="ite.value"
            />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="form.interviewerCode" size="small">
          <el-radio border :label="form.interviewerCode">{{form.interviewerName + form.interviewerCode}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 更换面试官： -->
      <el-form-item label="更换面试官" prop="replaceInterviewer">
        <el-select v-model="form.replaceInterviewer" placeholder="请选择" @change="getReplaceReferrerlist">
          <el-option
            v-for="(ite,idx) in interviewerList"
            :key="idx"
            :label="ite.label"
            :value="ite.value"
            />
        </el-select>
      </el-form-item>
      <el-form-item prop="replaceAgentCode">
        <el-radio-group v-model="form.replaceAgentCode" size="small">
          <el-radio
            border
            v-for="(ite,idx) in replaceAgentList"
            :key="idx"
            :label="ite.leaderId"
          >{{ite.leaderName + ite.leaderId}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="btns">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
        
<script>
import url from "@/modules/url";
import api from "@/modules/api";
import { Options } from '@/components/utils/fixOptions'
export default {
  data() {
    return {
      dialogVisible: true, // 控制对话框的显示与隐藏
      form: {},
      stepList: Options.step_status,
      interviewerList: Options.interviewerType_status,
      agentList: [],
      replaceAgentList: [],
      rules: {
        replaceInterviewer:[
          { required: true, message: '请选择更换面试官角色', trigger: 'change' }
        ],
        replaceAgentCode:[
          { required: true, message: '请选择更换面试官', trigger: 'change' }
        ]
      }
    };
  },
  props: {
    detailObj: {
      type: Object,
      default: {}
    },
  },
  mounted() {
    // 
    let type = '2'
    this.form = this.detailObj
    this.form.interviewerType = type
    console.log(this.form,'genghuan ')
  },
  methods: {
    getReplaceReferrerlist(val) {
      const { reference, orgCode, areaCode } = this.detailObj
      const referrerCode = reference.split("-")[0]
      api.post(url.getInterviewers, {interviewerType: val, referrerCode: referrerCode,orgCode: orgCode,areaCode: areaCode}, (res) => {
        if (res.result.isSuccess) {
          this.replaceAgentList = res.data
          if (val == '1' 
              && this.replaceAgentList && this.replaceAgentList.length > 0) {
            this.form.replaceAgentCode = this.replaceAgentList[0].leaderId
          }
        } else {
          this.$message({
            type: 'error',
            message: res.result.error
          }); 
        }
      });
    },
    // 提交表单
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.form.interviewerCode === this.form.replaceAgentCode) {
            this.$message.error('请选择更换之后的面试官,更换之后的面试官不能与当前面试官为同一个人');
            return;
          }
          const { userId, replaceAgentCode, step, replaceInterviewer } = this.form
          const agentName = this.replaceAgentList.find(item=> item.leaderId == replaceAgentCode).leaderName
          const data = {
            userId: userId,
            agentCode: replaceAgentCode,
            agentName: agentName,
            step: step,
            interviewerType: replaceInterviewer,
          }
          console.log("提交成功", data);
          debugger
          this.save(data)
        } else {
          this.$message.error("表单验证失败");
          return false;
        }
      });
    },

    handleClose(flag="") {
      this.form = {};
      this.$emit("close");
      flag == 'refresh' && this.$emit("refresh");
    },
    save(data) {
      api.post(url.changeReviewer, data, (res) => {
        if (res.result.isSuccess) {
          this.handleClose("refresh");
        } else {
          if (res.result.errors.length > 0) {
            this.$message({
              type: "error",
              message:
                res.result.errors[0].errorCode + res.result.errors[0].error,
            });
          } else {
            this.$message({
              type: "error",
              message: res.result.error,
            });
          }
        }
      });
    },
  },
};
</script>
      
<style lang="scss" scoped>
.btns {
  text-align: center;
}
.el-radio {
  margin-right: 10px !important;
}
.replace-header {
  margin: 0;
  padding: 0;
  display: flex;
  flex-flow: wrap;
  width: 100%;
  margin-bottom: 15px;
  li {
    width: 50%;
    list-style: none;
    padding: 10px 0;
    .label {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/recruit/officeSaff/component/replaceInterviewerDialog.vue